import { ChevronDown, ChevronUp } from 'lucide-react';

interface ClientMessageBannerProps {
  message: string;
  isExpanded: boolean;
  onToggle: () => void;
}

export function ClientMessageBanner({ message, isExpanded, onToggle }: ClientMessageBannerProps) {
  return (
    <div className={`bg-[#808080] text-white transition-all duration-300 overflow-hidden ${isExpanded ? 'max-h-40' : 'max-h-11'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between gap-4">
          {/* Message content */}
          <div
            className={`text-sm flex-1 transition-all duration-300 ${
              isExpanded ? 'opacity-100' : 'opacity-0 max-h-0'
            }`}
            dangerouslySetInnerHTML={{ __html: message.replace(/<br>/g, '') }}
          />

          {/* Toggle button */}
          <button
            onClick={onToggle}
            className={`flex-shrink-0 p-1.5 hover:bg-gray-700/50 rounded transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
              !isExpanded ? 'mx-auto' : ''
            }`}
            aria-label={isExpanded ? 'Collapse banner' : 'Expand banner'}
            aria-expanded={isExpanded}
          >
            {isExpanded ? (
              <ChevronUp className="w-4 h-4 text-gray-700" aria-hidden="true" />
            ) : (
              <ChevronDown className="w-4 h-4 text-gray-700" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
